<template>
  <div>
    <a-modal
      :title="audit ? '通用审批' : '通用申请详情'"
      :visible="is_show"
      width="60%"
      @cancel="is_show = false"
      :maskClosable="false"
      class="gufiiguy"
    >
      <template slot="footer">
        <a-button key="back" @click="is_show = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
      </template>
      <div ref="sadsada">
        <a-form-model :model="info" :label-col="labelCol3" :wrapper-col="wrapperCol3">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批标题"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批编号"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.applyCode }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="抄送人"
                  class="model_span_form"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                >
                  <span>{{ info.ccName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="申请内容"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span>{{ info.content }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批详情"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span>{{ info.detail }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path_img"
                    v-for="(item, index) in info.vouchers"
                    :key="index"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item.imgUrl" @click="show_img(index, info.vouchers)" />
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path"
                    @click="previewFile(item)"
                    v-for="(item, index) in info.attachment"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div class="title" v-if="!audit && recordNumber==1">
            <span>审批记录</span>
          </div>
          <div class="content" v-if="!audit && recordNumber==1">
            <auditModel ref="auditModel"></auditModel>
          </div>
        </a-form-model>
      </div>
    </a-modal>
    <!-- 撤销提示 -->
    <preview ref="preview" />
    <a-modal
      width="60%"
     @cancel="closeVisible"
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="closeVisible"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      
      <!-- <a-form-model v-if="result == 2 && record.taskDefKey == 'spr3_ty ' && record.processDefKey == 'universal'" :form="formData" :rules="rules" ref="passFormRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"> -->
		 <a-form-model :model="allform"  ref="allFormRef" v-if="result == 2 && record.taskDefKey == 'spr3_ty' && record.processDefKey == 'universal'"  :label-col="{ span: 6 }"
				:wrapper-col="{ span: 18 }">
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="下发公司"  prop="companyId" :rules="{
						  required: true,
						  message: '请选择处理人所属公司',
						  trigger: 'change',
						}">
					<a-select allowClear placeholder="请选择处理人所属公司" v-model="allform.companyId" @change="chooseDept" show-search :filter-option="filterOption"  >
						<a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
							{{ item.title }}
						</a-select-option>
					</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="下发部门"  prop="deptId" :rules="{
						  required: true,
						  message: '请选择处理人所属部门',
						  trigger: 'change',
						}">
						<a-select allowClear placeholder="请选择处理人所属部门" v-model="allform.deptId" @change="chooseUser" show-search :filter-option="filterOption"  >
						<a-select-option :value="item.deptId" v-for="(item, index) in deptList" :key="index">
							{{ item.title }}
						</a-select-option>
				   	</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="处理人" prop="name" :rules="{
						  required: true,
						  message: '请选择该申请的处理人',
						  trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择该申请的处理人" v-model="allform.name" show-search :filter-option="filterOption" >
						        <a-select-option :value="item.userId" v-for="(item, index) in users" :key="index">
							       {{ item.userName }}
						        </a-select-option>
					        </a-select>
						</a-form-model-item>
					</a-col>
        </a-row>
         <a-row>
        	<a-col :span="24" >
					<a-form-model-item allowClear  prop="comment" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }"
          :rules="{
						  required: true,
						  message: '请输入审批意见',
						  trigger: 'change',
						}">
            	<a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请输入审批意见" v-model="allform.comment" />
					</a-form-model-item>
				</a-col>
      </a-row>
    </a-form-model>
      <a-textarea placeholder="请输入审批意见" v-model="comment" v-else/>
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </div>
</template>
<script>
import auditModel from './audit.vue'
// import {	get_users2 } from '@/utils/unit_axios'
import { getUserList } from '@/api/system'
import {tree_all } from '@/api/purchase'
import { previewFileLists } from '@/utils/preview.js'
import { resolveBlob } from '@/utils/index'
import { axios } from '@/utils/request'
import { download_file_java } from '@/utils/request'
import { universal_apply_get } from '@/api/financial'
import { getClaimByBusiness, act_task_audit } from '@/api/activiti'
import { act_sku_num } from '@/api/assetmenag'
import { checkPermission } from '@/utils/permissions'
import preview from '@/components/module/prview'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
export default {
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    transferModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
     deptList: [],
      companyList: [],
      users: [],
      allform: {
          name: undefined,
          deptId: undefined,
          companyId: undefined,
          comment: ''
      },
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      is_show: false,
      info: {},
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
      labelCol2: {
        span: 3,
      },
      wrapperCol2: {
        span: 21,
      },
      labelCol3: {
        span: 9,
      },
      wrapperCol3: {
        span: 15,
      },
      record: null,
      assetsExportConsumables: checkPermission('asset:claim:checkSku'),
    }
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {
    console.log(this.assetsExportConsumables)
  },
  methods: {
       //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
 
     closeVisible() {
       if(this.result == 2 && this.record.taskDefKey == 'spr3_ty' && this.record.processDefKey == 'universal') {
       this.$refs.allFormRef.resetFields()
      }
        // this.$refs.passFormRef.resetFields()
        this.allform.name = undefined,
        this.allform.deptId = undefined,
        this.allform.companyId = undefined,
        this.allform.comment = ''
        this.is_revocation = false
    },
    // 获取部门列表
    chooseDept(e) {
       this.allform.deptId = ''
       this.allform.name = ''
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
      this.deptList = []
      this.companyList.forEach(item => {
        if(item.deptId == e ){
          this.deptList = item.children
        }
      })

    },
    //获取用户列表
    chooseUser(e) {
      this.allform.name = ''
      this.users = []
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeee2222222222222222')
     getUserList({
					deptId: e
				}).then(res => {
					if(res.code == 200){
            for(var i = res.rows.length - 1; i >= 0 ; i--) {
              if(res.rows[i].status == 1) {
                res.rows.splice(i, 1)
                }
               }

						this.users = res.rows
            this.$forceUpdate()
					} else {
						this.$message.error(res.msg)
					}
				})
    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    }, //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },

    // 			//预览文件
    // 			previewFile(file) {
    //                 let path = '/' + file.url.split('/')[0] + '/'
    //                 let fileName = file.url.substring(file.url.indexOf("/")+1)
    //                   axios({
    //                         url: `/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
    //                         method: 'post',
    //                          responseType: 'blob', // 必须要写
    //                         // headers: {
    //                         //  'Content-Type': 'application/json;charset=UTF-8'
    //                         // }
    //                        }).then((res)=>{
    //                             this.imgUrl = window.URL.createObjectURL(res)
    //                            resolveBlob({
    //                                data:res,
    //                                headers:{
    //                                    'content-disposition': `attachment;filename=${fileName}`
    //                                }
    //                                }) //新窗口打开，借用浏览器去打印
    //                        })
    // 			},
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    show(record, type = null) {
       this.recordNumber = record.recordNumber
      console.log(record, 'recordrecordrecordrecordrecordrecordrecord')
      this.record = record
      universal_apply_get(record.businessKey).then((res) => {
        console.log(res)
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.info = res.data
        previewFileLists(this.info.vouchers).then((res) => {
          this.info.vouchers = res
        })
        this.is_show = true
        this.$nextTick(() => {
          Watermark.set('安联云管家', this.$refs.sadsada)
           if(!this.audit && this.recordNumber==1) {
                 this.$refs.auditModel.show(record)
               }
        })
      })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else if (result_ === 2) {
        //获取公司数据
        tree_all().then(res => {
          if(res.code == 200) {
            this.companyList = res.data[0]
            this.allform = {
                name: undefined,
                deptId: undefined,
                companyId: undefined,
                comment: ''
            }
            this.is_revocation = true
            this.comment = ''
            this.result = result_
          } else {
            this.$message.error(res.msg)
          }
        })
        
      }
      else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason() {
      if(this.result == 2 && this.record.taskDefKey == 'spr3_ty' && this.record.processDefKey == 'universal') {
         this.$refs.allFormRef.validate(valid => {
            if(valid) {
                if (this.result == 3) {
                    if (this.comment == '') {
                      this.$message.error('请输入驳回意见！')
                    } else {
                      this.succeed(this.result)
                    }
                } else if (this.result == 2) {
                  this.succeed(this.result)
                }

            }
      })

      } else {
        if (this.result == 3) {
            if (this.comment == '') {
              this.$message.error('请输入驳回意见！')
            } else {
              this.succeed(this.result)
            }
        } else if (this.result == 2) {
          this.succeed(this.result)
        }

      }
     
     
    },
    //审批
    succeed(result_) {
      if(this.allform.comment) {
        this.comment = this.allform.comment
      }
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: result_,
        businessKey: this.record.businessKey,
        comment: this.comment,
        customizedUserId : this.allform.name,
        taskDefKey: this.record.taskDefKey
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.allform = {}
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
}
</script>
<style lang="less" scoped>
// /deep/ .content {
// 	padding-left: 10px  !important;
// }
// /deep/ .ant-form-item-label {
// 	text-align: left;

// }
</style>
